import { create } from "zustand";
import {
	createModalSlice,
	type IModalState,
} from "~/lib/stateManagement/sessionState/sessionSlices/modal";
import {
	createScrollSlice,
	type IScrollState,
} from "~/lib/stateManagement/sessionState/sessionSlices/scrollSlice";

export type ISessionState = IScrollState & IModalState;

export const useSessionStore = create<ISessionState>()((...a) => ({
	...createScrollSlice(...a),
	...createModalSlice(...a),
}));
